import {createContext} from 'react';
import { Page } from '../types/Page';

export type PageContextType = {
    page: Page | null;
    choosePage: (e:any) => void;
}
export const PageContext = createContext<PageContextType>(null!);